import React from "react";
import { ARTISTS, PARTNERS } from "@/data/content";
import { Reveal } from "./Reveal";

const Artists = () => {
  return (
    <section id="artists" className="py-24 sm:py-32 bg-neutral-50 border-y border-gray-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
            <div>
              <p className="text-sm font-medium tracking-widest text-neutral-400 mb-3">
                SELECTED CREDITS
              </p>
              <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight">
                Collaborations.
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {ARTISTS.map((a, i) => (
            <Reveal key={a.name} delay={i * 0.06}>
              <div
                data-testid={`artist-card-${i}`}
                className="group relative overflow-hidden rounded-3xl border border-gray-200 bg-white aspect-[3/4]"
              >
                <img
                  src={a.img}
                  alt={a.name}
                  className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <div className="absolute bottom-5 left-5 text-white">
                  <p className="font-heading text-lg font-semibold tracking-tight">{a.name}</p>
                  <p className="text-sm opacity-80">{a.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Partner strip */}
        <Reveal>
          <div className="mt-20">
            <p className="text-center text-xs font-medium tracking-widest text-neutral-400 mb-8">
              PARTNERS · PUBLISHERS · RIGHTS ORGANIZATIONS
            </p>
            <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
              {PARTNERS.map((p) => (
                <span
                  key={p}
                  className="font-heading text-lg sm:text-xl font-semibold tracking-tight text-neutral-400 hover:text-black transition-colors duration-300"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Artists;
